import React from "react";
import offer_gif from "../../../../images/come.gif";

/**
 * RM CROWN MARKET — Coming Soon
 * Drop-in replacement. Keeps the original local GIF asset and default export.
 * No extra dependencies, network calls, timers, or blocking loaders.
 */
const ComingSoonPage = () => (
  <main className="rmcs-root">
    <style>{`
      html, body, #root { background-color: #00191D !important; }
      body { margin: 0; }
      .rmcs-root {
        --rmcs-bg: #00191D;
        --rmcs-cyan: #16B8C7;
        --rmcs-white: #FFFFFF;
        --rmcs-muted: #A8C1C6;
        --rmcs-line: rgba(22,184,199,.24);
        box-sizing: border-box;
        width: 100%; min-height: 100vh;
        padding: 22px 4px 42px;
        background: #00191D; color: var(--rmcs-white);
        font-family: inherit; font-size: 14px; line-height: 1.55;
        overflow-x: clip;
      }
      .rmcs-root *, .rmcs-root *::before, .rmcs-root *::after { box-sizing: border-box; }
      .rmcs-shell { width: 100%; max-width: 1100px; margin: 0 auto; }
      .rmcs-topbar {
        display: flex; align-items: center; justify-content: space-between;
        gap: 14px; margin-bottom: 16px; padding: 13px 19px;
        border: 1px solid var(--rmcs-line); border-radius: 16px;
        background: #06252A;
      }
      .rmcs-brand { display: flex; align-items: center; gap: 11px; min-width: 0; }
      .rmcs-logo {
        width: 39px; height: 39px; flex-shrink: 0; border-radius: 12px;
        display: grid; place-items: center; font-weight: 900; font-size: 16px;
        background: linear-gradient(135deg, #63E1EA, #16B8C7 58%, #078A99);
        color: #002027;
      }
      .rmcs-brand strong { display: block; font-size: 14px; font-weight: 800; line-height: 1.2; color: white; letter-spacing: .4px; }
      .rmcs-brand small { display: block; margin-top: 4px; font-size: 11px; color: var(--rmcs-muted); }
      .rmcs-top-status { display: inline-flex; align-items: center; gap: 7px; color: #86E7EE; font-size: 12px; font-weight: 700; white-space: nowrap; }
      .rmcs-dot { width: 7px; height: 7px; border-radius: 50%; background: #3DE4B4; box-shadow: 0 0 0 4px rgba(61,228,180,.1); }
      .rmcs-main {
        position: relative; isolation: isolate; overflow: hidden;
        border: 1px solid rgba(22,184,199,.28); border-radius: 25px;
        background: linear-gradient(140deg, #073139 0%, #04252B 42%, #00191D 100%);
        padding: clamp(22px, 5vw, 54px);
        box-shadow: 0 20px 48px rgba(0,0,0,.16);
        display: grid; grid-template-columns: minmax(0,1fr) minmax(0, .92fr);
        gap: clamp(24px, 5vw, 58px); align-items: center;
      }
      .rmcs-main::before {
        content: ''; position: absolute; z-index: -1; width: 310px; height: 310px;
        right: -120px; top: -155px; border-radius: 50%;
        background: radial-gradient(circle, rgba(22,184,199,.17), transparent 70%);
        pointer-events: none;
      }
      .rmcs-copy { animation: rmcs-up .55s ease-out both; }
      .rmcs-eyebrow { display: inline-flex; align-items: center; gap: 7px; margin-bottom: 16px; color: #73E2E9; font-size: 11px; font-weight: 800; letter-spacing: 1.4px; text-transform: uppercase; }
      .rmcs-eyebrow::before { content: ''; display: inline-block; width: 22px; height: 2px; border-radius: 2px; background: #16B8C7; }
      .rmcs-heading { margin: 0 0 16px; color: white; font-size: clamp(30px, 4.5vw, 54px); font-weight: 850; letter-spacing: -1.3px; line-height: 1.13; }
      .rmcs-heading span { color: #58D8E3; }
      .rmcs-description { margin: 0 0 23px; color: #B6D0D4; font-size: 14px; line-height: 1.8; max-width: 430px; }
      .rmcs-pillrow { display: flex; flex-wrap: wrap; gap: 9px; margin-bottom: 26px; }
      .rmcs-pill { display: inline-flex; align-items: center; gap: 7px; padding: 8px 11px; border-radius: 999px; border: 1px solid rgba(22,184,199,.27); background: rgba(22,184,199,.075); color: #D9F5F7; font-size: 12px; }
      .rmcs-pill svg { color: #43D3DE; }
      .rmcs-note { display: flex; align-items: flex-start; gap: 10px; padding: 13px 14px; background: rgba(255,255,255,.055); border: 1px solid rgba(255,255,255,.09); border-radius: 13px; color: #BED3D6; font-size: 12px; }
      .rmcs-note svg { color: #5ADBE5; flex-shrink: 0; margin-top: 1px; }
      .rmcs-media { animation: rmcs-up .65s .08s ease-out both; min-width: 0; }
      .rmcs-media-frame {
        background: #fff; padding: clamp(10px,2.5vw,20px); border-radius: 22px;
        border: 1px solid rgba(255,255,255,.7);
        box-shadow: 0 16px 44px rgba(0,0,0,.23);
      }
      .rmcs-image { display: block; width: 100%; height: auto; max-height: 400px; object-fit: contain; border-radius: 12px; }
      .rmcs-media-caption { margin: 12px 0 0; text-align: center; color: #9CB9BD; font-size: 12px; }
      .rmcs-bottom { margin-top: 16px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding: 18px 20px; border-radius: 16px; border: 1px solid var(--rmcs-line); background: #05272D; }
      .rmcs-bottom strong { display: block; font-size: 14px; color: #fff; margin-bottom: 3px; }
      .rmcs-bottom p { margin: 0; color: #AAC5C9; font-size: 12px; }
      .rmcs-btn { display: inline-flex; align-items: center; justify-content: center; gap: 9px; min-height: 43px; padding: 10px 17px; border: 0; border-radius: 11px; background: linear-gradient(120deg, #66E3EB, #16B8C7 60%, #0795A4); color: #00242A !important; text-decoration: none !important; font: inherit; font-size: 13px; font-weight: 800; transition: transform .2s ease, box-shadow .2s ease; }
      .rmcs-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(22,184,199,.22); }
      .rmcs-btn:focus-visible { outline: 3px solid #B6F7FB; outline-offset: 3px; }
      .rmcs-footer { margin-top: 17px; text-align: center; color: #8CAAAF; font-size: 12px; }
      @keyframes rmcs-up { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
      @media (max-width: 800px) { .rmcs-main { grid-template-columns: 1fr; } .rmcs-copy { text-align: center; } .rmcs-description { margin-left: auto; margin-right: auto; } .rmcs-eyebrow, .rmcs-pillrow { justify-content: center; } .rmcs-note { text-align: left; } .rmcs-media { width: min(100%, 520px); margin: 0 auto; } }
      @media (max-width: 480px) { .rmcs-root { padding-top: 10px; } .rmcs-topbar { padding: 12px; } .rmcs-brand strong { font-size: 12px; } .rmcs-top-status { font-size: 10px; } .rmcs-main { border-radius: 18px; padding: 23px 15px; } .rmcs-heading { font-size: 32px; } .rmcs-bottom { padding: 15px; } .rmcs-btn { width: 100%; } }
      @media (prefers-reduced-motion: reduce) { .rmcs-copy, .rmcs-media { animation: none; } .rmcs-btn { transition: none; } }
    `}</style>

    <div className="rmcs-shell">
      <header className="rmcs-topbar">
        <div className="rmcs-brand">
          <div className="rmcs-logo" aria-hidden="true">RM</div>
          <div><strong>RM CROWN MARKET</strong><small>Innovation &amp; Digital Experience</small></div>
        </div>
        <div className="rmcs-top-status"><span className="rmcs-dot" /> Coming Soon</div>
      </header>

      <section className="rmcs-main" aria-labelledby="rmcs-heading">
        <div className="rmcs-copy">
          <div className="rmcs-eyebrow">Something exciting is on the way</div>
          <h1 id="rmcs-heading" className="rmcs-heading">We're building <span>something better.</span></h1>
          <p className="rmcs-description">A new experience is taking shape at RM CROWN MARKET. This section is coming soon, with a smarter and more seamless way to explore what's next.</p>
          <div className="rmcs-pillrow">
            <span className="rmcs-pill"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg> Modern Experience</span>
            <span className="rmcs-pill"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M12 3v18M3 12h18"/></svg> New Features</span>
          </div>
          <div className="rmcs-note"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 11v6M12 7h.01"/></svg><span>We haven't announced a launch date yet. Please check back for updates.</span></div>
        </div>
        <div className="rmcs-media">
          <div className="rmcs-media-frame"><img className="rmcs-image" src={offer_gif} alt="Coming soon preview" decoding="async" /></div>
          <p className="rmcs-media-caption">A preview of what's coming next</p>
        </div>
      </section>

      <section className="rmcs-bottom" aria-label="Explore more">
        <div><strong>Stay connected with RM CROWN MARKET</strong><p>Discover our latest updates on the main website.</p></div>
        <a className="rmcs-btn" href="https://rmcrownmarket.com/" target="_blank" rel="noopener noreferrer">Visit Website <span aria-hidden="true">↗</span></a>
      </section>
      <footer className="rmcs-footer">© RM CROWN MARKET · Coming Soon</footer>
    </div>
  </main>
);

export default ComingSoonPage;
